<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Select Dial Action</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="name"
                v-model="dial_actions.name"
                v-validate="'required'"
                data-vv-as="Name"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('name')"
              >{{ errors.first("name") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Action Type:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                label="name"
                name="action_type"
                :options="action_types"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="dial_actions.action_type"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('action_type')"
              >{{ errors.first("action_type") }}</span
            >
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Submit</vs-button
              >
            </div>
          </div>
          <vs-divider class="m-5" />

          <DataGrid :context="'ActionTypeOutcomeOption'" 
            ref="dial_actions"
            :columnDefs="columnDefs"
            :rowData="records"
            :dataSource="dataSource"
          >
          </DataGrid>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleActionTypeManagement from "@/store/action-type-management/moduleActionTypeManagement.js";
import moduleOutcomeManagement from "@/store/outcome-management/moduleOutcomeManagement.js";
import moduleAuditTrialManagement from "@/store/audit-trial-management/moduleAuditTrialManagement.js";
import vSelect from "vue-select";
export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
      action_types: [
      ],
      companySearchComponentKey: 0,
      columnDefs: [
        {
          headerName: "Name",
          flex: 1,
          field: "name",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
           {
        headerName: "Action Type",
        field: "action_type",
                flex:1,

        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      ],
      dataSource: {},
      records: [],
      selected: [],
      allDialActions: [],
      abilities: null,
      existing_list_values: [],
      existing_dial_actions_list: [],
      dial_actions: {
        name: null,
        action_type: null
      }
    };
  },
  components: {
    "v-select": vSelect,
    moduleOutcomeManagement,
    DataGrid
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleOutcomeManagement.isRegistered) {
      this.$store.registerModule("OutcomesManagement", moduleOutcomeManagement);
      moduleOutcomeManagement.isRegistered = true;
    }

      if (!moduleActionTypeManagement.isRegistered) {
      this.$store.registerModule(
        "ActionTypesManagement",
        moduleActionTypeManagement
      );
      moduleActionTypeManagement.isRegistered = true;
    }

      if (!moduleAuditTrialManagement.isRegistered) {
      this.$store.registerModule(
        "AuditTrialsManagement",
        moduleAuditTrialManagement
      );
      moduleAuditTrialManagement.isRegistered = true;
    }
  },
  mounted() {
    this.fetchAllActionTypes()
  },
  watch: {},
  methods: {
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          self.$store
            .dispatch("AuditTrialsManagement/getAllDialActions", params.request)
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.dial_actions.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.dial_actions.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function() {
      this.$router.go(-1);
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.selectDialActions();
        }
      });
    },
    fetchAllActionTypes() {
      var self = this;
      self.$store
            .dispatch(
              "OutcomesManagement/getAllActionTypesForOutcomes"
            )
            .then(function(response) {
              let response_data = response.data;
              self.action_types = response_data    
            })
            .catch(err => {
              console.log(err);
            });
    },
    selectDialActions() {
      
      this.dial_actions.call_action_type_id = this.dial_actions.action_type.id
      this.$store
        .dispatch("AuditTrialsManagement/selectDialActions", this.dial_actions)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Outcomes Exists",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Outcomes Added",
              text: "The dial_actions was added successfully"
            });
            this.$router.go(0);
            // this.$router.push({ path: "/dial_actions" });
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
